import React from 'react';
import { TAssistant } from 'types/common';
import { getAssistantList } from 'api/ehr';
import { EAddOnProductCode } from 'types/ehr';

let globalData:TAssistant[] = [];

const useAssistant = (productCode?: EAddOnProductCode.ASSISTANT_SEAT | EAddOnProductCode.ASSISTANT_EPRESCRIPTION_EPCS | EAddOnProductCode.ASSISTANT_EPRESCRIPTION):[TAssistant[], boolean, ()=>void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TAssistant[]>(globalData);
    const fetchData = async () => {
        if (loading || !productCode) return;
        try {
            setLoading(true);
            const result = await getAssistantList(productCode);
            if (!result.error) {
                const resData = result?.data?.data || [];
                globalData = resData;
                setItems(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        if (productCode) {
            fetchData();
        }
    }, [productCode]);

    return [items, loading, fetchData];
};

export default useAssistant;
